import { TemplateRef, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { CellPreparedEvent } from 'devextreme/ui/data_grid';
import { TemplatePortal } from '@angular/cdk/portal';

export class BeyondTableActions {
  overlayRef: OverlayRef;

  constructor(private overlay: Overlay,
              private viewContainerRef: ViewContainerRef,
              private actionsDropdownTemplate: TemplateRef<any>) {
  }

  init(e: CellPreparedEvent): void {
    e.cellElement.innerHTML = '';
    const actionButton = document.createElement('div');
    const img = document.createElement('img');
    img.src = 'assets/images/icons-optimized/dots.svg';
    img.style.cssText = 'height: 20px; opacity: 0.5;';
    actionButton.appendChild(img);

    e.cellElement.appendChild(actionButton);

    actionButton.addEventListener('click', (event) => {
      event.stopPropagation();
      this.openActionsDropdown(event.currentTarget as HTMLElement, e.data);
    });
  }

  openActionsDropdown(buttonElement: HTMLElement, rowData: any): void {
    this.closeActionsDropdown();

    const positionStrategy = this.overlay.position()
      .flexibleConnectedTo(buttonElement)
      .withPositions([
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close(),
      width: 150,
      hasBackdrop: true,
      backdropClass: '',
    });

    const templatePortal = new TemplatePortal(
      this.actionsDropdownTemplate,
      this.viewContainerRef,
      {$implicit: rowData}
    );
    this.overlayRef.attach(templatePortal);

    this.overlayRef.backdropClick()
      .subscribe(() => {
        this.closeActionsDropdown();
      });
  }

  closeActionsDropdown(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }
}
